var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.summary)?_c('missing-banners-summary',{attrs:{"data":_vm.data}}):_c('missing-banners-details',{attrs:{"data":_vm.data,"sites":_vm.sites,"definitions":_vm.definitions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }